module.exports = __webpack_public_path__ + "static/media/o-fr.b1206fa0.png";